<!-- <p>profile-sidebar works!</p> -->
<div class="side_bar_cont_outer">
	<div class="name_sidebar">
		<span class="name"*ngIf="userName">{{userName}}</span>
	</div>
	<div class="menu_outer">
		<div class="menu_inner">
			<a routerLink="dashboard" (click)="trackOption('Dashboard')" routerLinkActive="active_menu">Dashboard</a>
		</div>
		<div class="menu_inner">
			<a routerLink="order" (click)="trackOption('Orders')" routerLinkActive="active_menu">Orders</a>
		</div>
		<div class="menu_inner">
			<a routerLink="address" (click)="trackOption('Addresses')" routerLinkActive="active_menu">Addresses</a>
		</div>
		<div class="menu_inner">
			<a routerLink="account" (click)="trackOption('Account')" routerLinkActive="active_menu">Account</a>
		</div>
	</div>
</div>
